import { render, staticRenderFns } from "./metadata_item.vue.js?vue&type=template&id=178c2d70!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./metadata_item.vue?vue&type=template&id=178c2d70"
import script from "./metadata_item.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./metadata_item.vue?vue&type=script&lang=js"
export * from "./metadata_item.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./metadata_item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports